import React, { Fragment, useEffect, useState } from "react";
import { Card, Col, Modal, Row } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Select from "react-select";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { accountGroupCreate, accountGroupDelete, accountGroupList, accountGroupView } from "../../../services/accounts";

const GROUP_TYPES = [
  { value: "Asset",     label: "Asset" },
  { value: "Liability", label: "Liability" },
  { value: "Income",    label: "Income" },
  { value: "Expense",   label: "Expense" },
  { value: "Capital",   label: "Capital" },
];

export default function AccountGroups() {
  const [list, setList]         = useState([]);
  const [show, setShow]         = useState(false);
  const [gid, setGid]           = useState(0);
  const [groupName, setGroupName] = useState("");
  const [groupType, setGroupType] = useState("");
  const [error, setError]       = useState("");

  useEffect(() => { loadList(); }, []);

  function loadList() {
    const temp = new FormData();
    const academyId = localStorage.getItem("AAcademy") || localStorage.getItem("academy") || "";
    if (academyId) temp.append("academy_id", academyId);
    accountGroupList(temp).then((res) => {
      if (res?.status) setList(res.data);
    });
  }

  function handleAdd() {
    setGid(0); setGroupName(""); setGroupType(""); setError(""); setShow(true);
  }

  function handleEdit(id) {
    setGid(id); setGroupName(""); setGroupType(""); setError(""); setShow(true);
    accountGroupView(id).then((res) => {
      if (res?.status) {
        setGroupName(res.data.group_name);
        setGroupType(GROUP_TYPES.find((t) => t.value === res.data.group_type) || "");
      }
    });
  }

  function handleClose() { setShow(false); }

  function handleDelete(id) {
    Swal.fire({
      text: "Are you sure you want to delete this group?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        accountGroupDelete(id).then((res) => {
          if (res?.status) { toast.success(res.message); loadList(); }
          else toast.error(res?.message || "Cannot delete");
        });
      }
    });
  }

  function handleSubmit() {
    setError("");
    if (!groupName.trim()) { setError("Please enter group name"); return; }
    if (!groupType)        { setError("Please select group type"); return; }

    const payload = new FormData();
    payload.append("id", gid);
    payload.append("group_name", groupName);
    payload.append("group_type", groupType.value);
    const academyId = localStorage.getItem("AAcademy") || localStorage.getItem("academy") || "";
    if (academyId) payload.append("academy_id", academyId);
    accountGroupCreate(payload).then((res) => {
      if (res?.status) {
        toast.success(res.message); handleClose(); loadList();
      } else {
        setError(res?.message || "Something went wrong");
      }
    });
  }

  const columnDefs = [
    { headerName: "Group Name", field: "group_name", sortable: true, filter: true, floatingFilter: true, resizable: true, cellStyle: { textAlign: "left" } },
    { headerName: "Type",       field: "group_type", sortable: true, filter: true, floatingFilter: true, resizable: true, width: 130 },
    {
      headerName: "Actions", field: "id", width: 120, filter: false, resizable: true,
      cellRenderer: (params) => (
        <div className="text-center">
          <a onClick={() => handleEdit(params.value)} className="btn-sm btn-info me-2"><i className="fa fa-edit" /></a>
          <a onClick={() => handleDelete(params.value)} className="btn-sm btn-danger"><i className="fa fa-trash" /></a>
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Account Groups</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Accounts</a></li>
            <li className="breadcrumb-item active">Account Groups</li>
          </ol>
        </div>
      </div>

      <Row className="row-sm mx-0 mt-3">
        <Col xxl={12} lg={12} md={12}>
          <Card className="custom-card overflow-hidden">
            <Card.Body>
              <div className="responsive">
                <div className="res-right">
                  <a onClick={handleAdd} className="btn my-1 me-2 btn-success tx-teko">Add</a>
                </div>
                <div className="ag-theme-alpine ag-style">
                  <AgGridReact columnDefs={columnDefs} rowData={list} pagination paginationPageSize={10} suppressDragLeaveHidesColumns />
                </div>
              </div>

              <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                  <h4>{gid === 0 ? "Add" : "Edit"} Account Group</h4>
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    <Col lg={12} md={12} className="mb-3">
                      <label className="mb-2">Group Name <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" placeholder="e.g. Current Assets" value={groupName} onChange={(e) => setGroupName(e.target.value)} />
                    </Col>
                    <Col lg={12} md={12} className="mb-3">
                      <label className="mb-2">Group Type <span className="text-danger">*</span></label>
                      <Select className="default-select" placeholder="Select Type" options={GROUP_TYPES} value={groupType} onChange={(e) => setGroupType(e)} isClearable />
                    </Col>
                    {error && <span className="text-danger">{error}</span>}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <a onClick={handleSubmit} className="btn btn-success">{gid === 0 ? "Submit" : "Update"}</a>
                  <a onClick={handleClose} className="btn btn-secondary">Close</a>
                </Modal.Footer>
              </Modal>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
}
